import { createSlice } from "@reduxjs/toolkit";
import { CreateDevice, DeleteDevice, FetchDeviceList } from "./deviceAction";



const initialState: any = {
  deviceList: [],
  loading: false,
  error: null,
  totalRecord:0
};

const deviceSlice = createSlice({
  name: 'deviceList',
  initialState,
  reducers: {
    addNewDevice: (state, { payload }) => {
      let latestDeviceList: any = [...state.deviceList, payload?.data];
      state.deviceList = latestDeviceList;
    },
    removeDevice: (state, { payload }) => {
      let latestDeviceList: any = [...state.deviceList].filter((p: any) => p?._id !== payload);
      state.deviceList = latestDeviceList;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(FetchDeviceList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FetchDeviceList.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.deviceList = payload.data;
        state.totalRecord = payload?.totalRecord || 0;
      })
      .addCase(FetchDeviceList.rejected, (state, { payload }) => {
        state.loading = false;
        state.error =
          (payload as { responseMessage?: string })?.responseMessage || "Failed to fetch device list";
      });
  },
});


const createDevice = createSlice({
  name: 'CreateProperty',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(CreateDevice.pending, (state: any) => {
        state.loading = true;
        state.error = null; // Reset error on pending request
      })
      .addCase(CreateDevice.fulfilled, (state: any, { payload }) => {
        state.loading = false;
      })
      .addCase(CreateDevice.rejected, (state: any, action: any) => {
        state.loading = false;
      });
  }

});

const deleteProperty = createSlice({
  name: 'deleteProperty',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(DeleteDevice.pending, (state: any) => {
        state.loading = true;
        state.error = null; // Reset error on pending request
      })
      .addCase(DeleteDevice.fulfilled, (state: any, action: any) => {
        state.loading = false;
      })
      .addCase(DeleteDevice.rejected, (state: any, action: any) => {
        state.loading = false;
      });
  },
});


export const {   addNewDevice, removeDevice
} = deviceSlice.actions;

export const deviceReducer = deviceSlice.reducer;
export const deleteDeviceSlice = deleteProperty.reducer;
export const createDeviceSlice = createDevice.reducer;
